/**
 * Adds together an array of numbers
 *
 * @format
 */

export const sum = (array: number[]) => {
    return array.reduce((sum, acc) => {
        return sum + acc;
    }, 0);
};
